import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPapers = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 16,
	fill: "none",
	viewBox: "0 0 17 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#E0E0E0",
		d: "M3.167 4H1.834v9.333c0 .734.6 1.334 1.333 1.334H12.5v-1.334H3.167V4zm10.666-2.667h-8c-.733 0-1.333.6-1.333 1.334v8C4.5 11.4 5.1 12 5.833 12h8c.734 0 1.334-.6 1.334-1.333v-8c0-.734-.6-1.334-1.333-1.334zm-.666 6H6.5V6h6.667v1.333zM10.5 10h-4V8.667h4V10zm2.667-5.333H6.5V3.333h6.667v1.334z"
	})
});
export default SvgIconPapers;
